import {gql} from 'apollo-angular';
export const GET_GAME_ACTIVE_USERS = gql`
  query GetGameActiveUsers($game: GameType!) {
    getGameActiveUsers(gameType: $game)
  }
`;
